import { Tag } from 'antd';
import { Link } from 'react-router-dom';
import { formatDateTime } from 'utils/formatDate';

const statusColors: Record<number, string> = { 1: 'green', 2: 'grey' };
const statusLabels: Record<number, string> = { 1: 'Active', 2: 'Closed' };

const fmtNum = (v: number, decimals = 2) =>
  v.toLocaleString('vi-VN', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });

export const columnsGenerator = () => [
  {
    title: 'Customer',
    dataIndex: 'user_name',
    key: 'user_name',
    render: (user_name: string, record: any) => (
      <Link to={`/wealth/programs/${record.id}`}>
        <div className="font-medium">{user_name || '—'}</div>
      </Link>
    ),
  },
  {
    title: 'Status',
    dataIndex: 'status',
    key: 'status',
    render: (status: number) => (
      <Tag color={statusColors[status] ?? 'default'}>
        {statusLabels[status] ?? status}
      </Tag>
    ),
  },
  {
    title: 'NAV',
    dataIndex: 'nav',
    key: 'nav',
    render: (nav: number) =>
      nav != null ? <span className="font-mono">{fmtNum(nav, 2)}</span> : '—',
  },
  {
    title: 'NAV Date',
    dataIndex: 'nav_date',
    key: 'nav_date',
    render: (d: string) => (d ? new Date(d).toLocaleDateString('vi-VN') : '—'),
  },
  {
    title: 'Total AUM',
    dataIndex: 'market_value',
    key: 'market_value',
    render: (market_value: number) =>
      market_value != null ? <span>{fmtNum(market_value / 1_000_000, 1)}M</span> : '—',
  },
  {
    title: 'Quantity',
    dataIndex: 'quantity',
    key: 'quantity',
    render: (quantity: number) =>
      quantity != null ? <span className="font-mono">{fmtNum(quantity, 2)}</span> : '—',
  },
  {
    title: 'Since Inception',
    dataIndex: 'performance',
    key: 'portfolio_return_pct',
    render: (performance: any) => {
      const ret = performance?.portfolio_return_pct;
      if (ret == null) return '—';
      const color = ret >= 0 ? 'text-green-600' : 'text-red-500';
      return (
        <span className={`font-medium ${color}`}>
          {ret >= 0 ? '+' : ''}{ret.toFixed(2)}%
        </span>
      );
    },
  },
  {
    title: 'Start Date',
    dataIndex: 'start_date',
    key: 'start_date',
    render: (d: string) => (d ? new Date(d).toLocaleDateString('vi-VN') : '—'),
  },
  {
    title: 'Created',
    dataIndex: 'created_at',
    key: 'created_at',
    render: (v: string) => formatDateTime(v),
  },
];
